
import { Injectable } from '@angular/core';
import { Negociacion } from './negociacion';
import { NegociacionResidencial } from './negociacion-residencial';
import { SuscripcionBoletaElectronica } from './suscripcion-boleta-electronica';
import { RestriccionConvenio } from './restriccion-convenio';
import { ModificacionDatos } from './modificacion-datos';
import { PagoErroneo } from './pago-erroneo';
import { TrasladoMetrobolsa } from './traslado-metrobolsa';
import { BeneficioClientesVulnerablesCovid19 } from './beneficio-clientes-vulnerables-covid19';
import { VentaReguladores } from './venta-reguladores';
import { Observable, of, throwError, timer } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Configuracion } from '../models/Configuracion';
import { PagoDuplicado } from './pago-duplicado';
import { CambioNombreBoleta } from './cambio-nombre-boleta';
import { Contactenos } from './contactenos';
import { Tracking } from './tracking';
import { environment } from '../../environments/environment';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Injectable({
  providedIn: 'root'
})

export class ApiService {

  endpoint: string = environment.API_URL;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  public configuracion: Configuracion;

  constructor(private http: HttpClient, private recaptchaV3Service: ReCaptchaV3Service) { }

  // Consultas por numero de cliente: el backend exige un token reCAPTCHA v3
  // (header X-Recaptcha-Token) para impedir la enumeracion masiva de cuentas.
  private getConRecaptcha(url: string, accion: string): Observable<any> {
    return this.recaptchaV3Service.execute(accion).pipe(
      switchMap(token => this.http.get<any>(url, { headers: new HttpHeaders().set('X-Recaptcha-Token', token) }))
    );
  }
  AgregarAgendamiento(formulario: FormData): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-agendamiento`;

    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }
  LeerHorasAgendamiento(formulario: FormData, data: Negociacion): Observable<any> {
    let API_URL = `${this.endpoint}/leer-horas-agendamiento`;

    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  LeerSucursalesAgendamiento(): Observable<any> {
    let API_URL = `${this.endpoint}/leer-sucursales-agendamiento`;

    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarNegociacion(formulario: FormData, data: Negociacion): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-negociacion`;

    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarNegociacionComercio(formulario: FormData, data: Negociacion): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-negociacion-comercio`;

    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarNegociacionResidencial(formulario: FormData, data: NegociacionResidencial): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-negociacion-residencial`;

    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarSuscripcionBoletaElectronica(formulario: FormData, data: SuscripcionBoletaElectronica): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-suscripcion-boleta-electronica`;

    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarRestriccionConvenio(formulario: FormData, data: RestriccionConvenio): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-restriccion`;
    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarModificacionDatos(formulario: FormData, data: ModificacionDatos): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-modificacion`;
    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarPagoErroneo(formulario: FormData, data: PagoErroneo): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-pago-erroneo`;
    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarPagoDuplicado(formulario: FormData, data: PagoDuplicado): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-pago-duplicado`;
    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarTrasladoMetrobolsa(formulario: FormData, data: TrasladoMetrobolsa): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-traslado-metrobolsa`;
    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarBeneficioClientesVulnerablesCovid19(formulario: FormData, data: BeneficioClientesVulnerablesCovid19): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-beneficio-clientes-vulnerables-covid19`;
    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarBeneficioClientesVulnerablesCovid19V2(formulario: FormData, data: BeneficioClientesVulnerablesCovid19): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-beneficio-clientes-vulnerables-covid19-v2`;
    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarventaReguladores(formulario: FormData, data: VentaReguladores): Observable<any> {
    let API_URL = `${this.endpoint}/agregar-venta-reguladores`;
    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarCambioNombreBoleta(formulario: FormData, data: CambioNombreBoleta): Observable<any> {
    let API_URL = `${this.endpoint}/cambio-nombre-boleta`;
    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }
  //revisar
  AgregarContacto(formulario: FormData): Observable<any> {
    let API_URL = `${this.endpoint}/contactenos`;
    return this.http.post(API_URL, formulario)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  AgregarTracking(formulario: FormData, data: Tracking): Observable<any> {
    let API_URL = `${this.endpoint}/tracking`;
    return this.http.post(API_URL, data,{headers: this.headers})
      .pipe(
        catchError(this.errorMgmt)
      );
  }

  LeerDetalleSolicitudesBeneficioCovid19(): Observable<any> {
    let API_URL = `${this.endpoint}/leer-detalle-solicitudes-beneficio-covid19`;
    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  LeerDetalleSolicitudesBeneficioCovid19V2(): Observable<any> {
    let API_URL = `${this.endpoint}/leer-detalle-solicitudes-beneficio-covid19-v2`;
    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  LeerComuna(): Observable<any> {
    let API_URL = `${this.endpoint}/leer-comuna`;
    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  LeerComunaRegion(idRegion): Observable<any> {
    let API_URL = `${this.endpoint}/leer-comuna/${idRegion}`;
    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  LeerRegion(): Observable<any> {
    let API_URL = `${this.endpoint}/leer-region`;
    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  LeerDatosPorNumeroCliente(numeroCliente): Observable<any> {
    let API_URL = `${this.endpoint}/leer-cliente/${numeroCliente}`;
    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  LeerDatosDirecciones(id_region, id_comuna, direccion): Observable<any> {
    let API_URL = `${this.endpoint}/leer-direccion-cliente/${id_region}/${id_comuna}/${direccion}`;
    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  LeerTipoInstitucion(): Observable<any> {
    let API_URL = `${this.endpoint}/leer-tipo-institucion`;
    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  LeerConfiguracion(): Observable<any> {
    let API_URL = `${this.endpoint}/leer-configuracion`;
    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      )
  }

  LeerCliente(numeroCliente): Observable<any> {
    let API_URL = `${this.endpoint}/cliente/${numeroCliente}`;
    return this.getConRecaptcha(API_URL, 'ConsultaCliente')
      .pipe(
        catchError(this.errorMgmt)
      );
  }

  LeerAviso(idTransaccion): Observable<any> {
    let API_URL = `${this.endpoint}/solicitud/${idTransaccion}`;
    return this.http.get(API_URL)
      .pipe(
        catchError(this.errorMgmt)
      );
  }

  CargarConfiguracion():  Promise<any> {
    let API_URL = `${this.endpoint}/leer-configuracion`;

    return this.http.get<any>(API_URL).toPromise().then((result) => {
      this.configuracion = (result);
    }).catch((error) => {
      return this.http.get<any>('./assets/configuracion.json').toPromise().then((result) => {
        this.configuracion = (result);
        console.log(this.configuracion);
      });
    });
  }

  //  Error handling
  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    //console.log(error);

    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

  // VALIDACIONES
  public checkCliente(input: string) {
    return this.getConRecaptcha(`${this.endpoint}/cliente/${input}`, 'ConsultaCliente');
  }

  // DATOS CLIENTE
  public estadoCliente(input) {
    return this.getConRecaptcha(`${this.endpoint}/cliente/estadocuenta/${input}`, 'EstadoCuentaCliente');
  }

  //ru1 validar rut
  validateRut(Rut: String): Observable<any> {
    const url = `${this.endpoint}/ru1consultar`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(url, { Rut }, { headers });
  }
  
  createRut(Rut: String, nombre: string, apellidoPaterno: string, apellidoMaterno: string, telefono: string, email: string, numero_cliente: string): Observable<any> {
    const url = `${this.endpoint}/ru1crear`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      Rut: Rut,
      Nombre: nombre,
      ApellidoPaterno: apellidoPaterno,
      ApellidoMaterno: apellidoMaterno,
      Telefono: telefono,
      CorreoElectronico: email,
      NumeroCliente: numero_cliente
    };
    return this.http.post(url, body, { headers });
  }

  //ru5
  sendEmail(nombre: string, mail: string, requestId: string): Observable<any> {
    const subject = 'Solicitud Recibida';
    const text = `Estimado cliente ${nombre},\n\nHemos recibido exitosamente tu solicitud Nº ${requestId}.\nPara conocer en qué estado se encuentra su solicitud ingrese al siguiente enlace:\nhttps://www.centrodeayudametrogas.cl/tracking\n\nGracias por contactarse con nosotros.\nCentro de Ayuda Metrogas S.A.`;
    const emailData = { to: mail, subject, text };
    return this.http.post<any>(`${this.endpoint}/send-email`, emailData);
  }

  //Ru7
  ConsultaSuscripcionBoletaElectronicaIC(ic: String) {
    const body = {
      IC: ic,
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(`${this.endpoint}/revision-suscripcion`, body, { headers });
  }

  // CALLEJERO
  searchComunas(query: string): Observable<any> {

    const body = {
      query: query
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(`${this.endpoint}/searchComunas`, body, { headers });
  }

  searchCalle(comunaId: number, calleNombre: string): Observable<any> {
    const body = {
      comuna: {
        id: comunaId
      },
      nombre: calleNombre,
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(`${this.endpoint}/searchCalle`, body, { headers });
  }
  
  searchNumero(calleId: number, calleNombre: string): Observable<any> {
    const body = {
      id: calleId,
      nombre: calleNombre,
    };
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(`${this.endpoint}/searchNumero`, body, { headers });
  }

  searchAdicional(calleId: number, calleNombre: string, adicional: string): Observable<any> {
    const body = {
      id: calleId,
      nombre: calleNombre,
      adicional: adicional,
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(`${this.endpoint}/searchAdicional`, body, { headers });
  }
  
  searchCliente(id: number, numero: string, complemento: string): Observable<any> {
    const body = {
      calle: {
        id: id
      },
      numero: numero,
      complemento: complemento,
    };
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(`${this.endpoint}/searchCliente`, body, { headers });
  }

  // Obtener constancia del reclamo
  obtenerConstanciaReclamo(numeroCliente: string, numeroAviso: string): Observable<any> {
    const url = `${this.endpoint}/ru1obtenerconstancia`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      NumeroCliente: numeroCliente,
      NumeroAviso: numeroAviso
    };
    return this.http.post(url, body, { headers });
  }
}
